import { BLOCK_CLASSES as e, DISALLOWED_COLOR_VALUES as t, FONT_FAMILIES as n } from "../../constants.js";
import { defineAttrs as r } from "../../utils/typed-attrs.js";
import { tinycolor as i } from "../../bundled_deps/.pnpm/tinycolor2@1.6.0/bundled_deps/tinycolor2/esm/tinycolor.js";
//#region src/specs/decorators/stylable.ts
var a = r({
	fontFamily: { default: "" },
	fontColor: { default: "" },
	backgroundColor: { default: "" },
	paddingTop: { default: "" },
	paddingBottom: { default: "" },
	paddingLeft: { default: "" },
	paddingRight: { default: "" },
	borderRadius: { default: "" },
	borderColor: { default: "" },
	borderWidth: { default: "" },
	borderStyle: { default: "" }
});
function o(e) {
	let t = "";
	return e.attrs.paddingTop && (t += `padding-top: ${e.attrs.paddingTop}; `), e.attrs.paddingBottom && (t += `padding-bottom: ${e.attrs.paddingBottom}; `), e.attrs.paddingLeft && (t += `padding-left: ${e.attrs.paddingLeft}; `), e.attrs.paddingRight && (t += `padding-right: ${e.attrs.paddingRight}; `), t;
}
function s(r) {
	r.attrs = Object.assign({}, r.attrs, {
		fontFamily: { default: "" },
		fontColor: { default: "" },
		backgroundColor: { default: "" },
		paddingTop: { default: "" },
		paddingBottom: { default: "" },
		paddingLeft: { default: "" },
		paddingRight: { default: "" },
		borderRadius: { default: "" },
		borderColor: { default: "" },
		borderWidth: { default: "" },
		borderStyle: { default: "" }
	}), r.parseDOM?.forEach(function(r) {
		let a = r.getAttrs;
		r.getAttrs = (r) => {
			let o = {};
			a && Object.assign(o, a(r));
			let { fontFamily: s, color: l, borderRadius: u, paddingTop: d, paddingBottom: f, paddingLeft: p, paddingRight: m } = r?.style || {};
			if (s && n.includes(s) && Object.assign(o, { fontFamily: s }), l && !t.includes(l) && i(l).isValid()) {
				let e = i(l).toHexString();
				Object.assign(o, { fontColor: e });
			}
			if ((d || p || m || f) && Object.assign(o, {
				paddingTop: d,
				paddingLeft: p,
				paddingRight: m,
				paddingBottom: f
			}), u && Object.assign(o, { borderRadius: u }), r.classList.contains(e.button) || r.classList.contains("intercom-interblocks-button")) {
				let e = c(r.firstChild);
				Object.assign(o, e);
			}
			return o;
		};
	});
	let a = r.toDOM;
	return r.toDOM = (e) => {
		if (!a) throw Error("must specify a toDOM method");
		let t = a(e);
		if (!Array.isArray(t) || t.length < 2) throw Error("must specify at least two elements in output spec");
		t[1] === 0 && t.splice(1, 0, {});
		let n = t[1], r = t[2] ? t[2][1] : {};
		return n.style ??= "", r.style ??= "", e.attrs.fontFamily && (n.style += `font-family: ${e.attrs.fontFamily}; `), e.attrs.borderRadius && (r.style += `border-radius: ${e.attrs.borderRadius}; `), e.attrs.fontColor && (n.style += `color: ${e.attrs.fontColor}; `), e.attrs.backgroundColor && (e.attrs.responsive ? r.style += `background-color: ${e.attrs.backgroundColor}; ` : e.type.name !== "button" && !e.attrs.container && (n.style += `background-color: ${e.attrs.backgroundColor}; `)), e.attrs.borderColor && (n.style += `border-color: ${e.attrs.borderColor}; `), l(e) && (e.attrs.container ? n.style += o(e) : (r.style += o(e), e.attrs.responsive && (r.style += "border-collapse: separate; "))), n.style = n.style.trim(), r.style = r.style.trim(), n.style === "" && (n.style = null), r.style === "" && (r.style = null), t;
	}, r;
}
function c(e) {
	let { paddingTop: t, paddingRight: n, paddingLeft: r, paddingBottom: i, borderRadius: a, borderColor: o, borderWidth: s, borderStyle: c } = e?.style || {};
	return {
		paddingTop: t,
		paddingRight: n,
		paddingLeft: r,
		paddingBottom: i,
		borderRadius: a,
		borderColor: o,
		borderWidth: s,
		borderStyle: c
	};
}
function l(e) {
	let { paddingTop: t, paddingRight: n, paddingLeft: r, paddingBottom: i } = e.attrs;
	return !!(t || n || r || i);
}
//#endregion
export { o as getPaddingStyles, s as stylable, a as stylableAttrs };
